var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 .313a5.687 5.687 0 100 11.374A5.687 5.687 0 006 .313zm4.792 5.25H8.614c-.077-1.557-.562-3.034-1.374-4.211a4.824 4.824 0 013.552 4.21zM6 10.806c-1.024-1.109-1.646-2.68-1.737-4.37h3.474C7.646 8.127 7.024 9.698 6 10.808zM4.263 5.561c.091-1.688.71-3.26 1.737-4.368 1.024 1.108 1.646 2.68 1.737 4.369H4.263zm.497-4.21c-.812 1.177-1.297 2.654-1.374 4.21H1.208a4.823 4.823 0 013.552-4.21zM1.208 6.437h2.178c.077 1.557.562 3.034 1.374 4.211a4.823 4.823 0 01-3.552-4.21zm6.032 4.211c.812-1.179 1.297-2.656 1.374-4.21h2.178a4.823 4.823 0 01-3.552 4.21z",
    fill: "#1B1B1B"
  })));
}

export default SvgGlobe;